import angularJsUtilitiesModule from '../angularJsUtilitiesModule';

function escapeHtml() {
  const entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
  };

  return str => {
    return String(str).replace(/[&<>"'\\/]/g, s => {
      return entityMap[s];
    });
  };
}

angularJsUtilitiesModule.filter('escapeHtml', escapeHtml);
export default escapeHtml;
